import AsonicSearch from "../../../../components/main-view/WorkManagementInfo/Tree/asonic-search/asonic-search";
import stateManager from "./stateManager";

const SearchContainer = WrappedComponent => props => {
  const newProps = stateManager();
  return <WrappedComponent {...props} {...newProps} />;
};

export default SearchContainer(AsonicSearch);
